<template>

    <b-row class="mb-2" v-if="containerList.length > 0">
        <b-col cols="12">
            <table id="ffContainer" class="table table-bordered" v-if="containerList.length > 0">
                <thead>
                    <tr>
                        <th>
                            <input
                                type="checkbox"
                                v-model="selectAllContainers"
                                @change="toggleSelectAll"
                                :indeterminate="isIndeterminate"
                            />
                        </th>
                        <th>SN.</th>
                        <th>Container Type</th>
                        <th>Container No.</th>
                        <th>Line Seal No</th>
                        <th>Custom Seal No</th>
                        <th>Gross Weight</th>
                        <th>Measurement</th>
                        <th>Net Weight</th>
                        <th>Tare Weight</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in containerList" :key="index">
                        <td>
                            <input
                                type="checkbox"
                                v-model="item.selected"
                                @change="updateSelectAll"
                                :disabled="item.containerWithSplit == 1"
                            />
                        </td>
                        <td>{{ index + 1 }}</td>

                        <td>{{ item.containerType }}</td>

                        <td>{{ item.containerNo }}</td>
                        <td>{{ item.LineSealNo }}</td>
                        <td>{{ item.customSealNo }}</td>
                        <td v-if="editIndex === index">
                            <input type="text" v-model="editableRow.gross_weight" class="form-control"
                                :class="{ 'is-invalid': errorContainerList.gross_weight }" />
                            <div class="invalid-feedback" v-if="errorContainerList.gross_weight">
                                {{ errorContainerList.gross_weight }}
                            </div>
                        </td>
                        <td v-else>{{ item.gross_weight }}</td>
                        <td v-if="editIndex === index">
                            <input type="text" v-model="editableRow.measurement" class="form-control"
                                :class="{ 'is-invalid': errorContainerList.measurement }" />
                            <div class="invalid-feedback" v-if="errorContainerList.measurement">
                                {{ errorContainerList.measurement }}
                            </div>
                        </td>
                        <td v-else>{{ item.measurement }}</td>
                        <td v-if="editIndex === index">
                            <input type="text" v-model="editableRow.net_weight" class="form-control"
                                :class="{ 'is-invalid': errorContainerList.net_weight }" />
                            <div class="invalid-feedback" v-if="errorContainerList.net_weight">
                                {{ errorContainerList.net_weight }}
                            </div>
                        </td>
                        <td v-else>{{ item.net_weight }}</td>
                        <td v-if="editIndex === index">
                            <input type="text" v-model="editableRow.tare_weight" class="form-control"
                                :class="{ 'is-invalid': errorContainerList.tare_weight }" />
                            <div class="invalid-feedback" v-if="errorContainerList.tare_weight">
                                {{ errorContainerList.tare_weight }}
                            </div>
                        </td>
                        <td v-else>{{ item.tare_weight }}</td>
                        <td v-if="item.uniqueContainerId && item.allModuleId && !item.cont_sob_status">
                            <button v-if="editIndex === index" @click="saveContainer(index)"
                                class="btn btn-success btn-sm">
                                Save
                            </button>
                            <button v-if="editIndex === index" @click="cancelEdit()" class="btn btn-secondary btn-sm">
                                Cancel
                            </button>
                            <button v-else @click="editContainer(item, index)" class="btn btn-primary btn-sm">
                                Edit
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="mt-3" v-if="containerList.length > 0">
                <div class="alert alert-info">
                    <strong>Container Selection:</strong> Use the checkboxes to select individual containers or use the controls below for bulk operations. Containers with split status are disabled.
                </div>
                <div class="row align-items-center">
                    <div class="col-md-6 mb-2">
                        <button type="button" class="btn btn-sm btn-info mr-2" @click="selectAllContainers = true; toggleSelectAll()">Select All</button>
                        <button type="button" class="btn btn-sm btn-secondary" @click="selectAllContainers = false; toggleSelectAll()">Deselect All</button>
                    </div>
                    <div class="col-md-6 text-right">
                        <span class="text-muted">Selected: {{ selectedContainersCount }} of {{ selectableContainersCount }} containers</span>
                    </div>
                </div>
            </div>
        </b-col>
        <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-confirm>
    </b-row>

</template>

<script>
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
import NodeLockPannelService from "../../services/NodeLockPannelService";
export default {
    props: {
        allModuleId: { type: Number, default: null },
        JobNo: { type: String, default: null },
        ClientId: { type: Number, default: null },
        MultiClientId: { type: Number, default: null },
        ffFclConsoExportId: { type: Number, default: null },
        showContainerClient: { type: Boolean, default: false },
    },
    beforeMount() {
        if (this.allModuleId) {// && this.ClientId && this.MultiClientId && this.ffFclConsoExportId
            this.getContainerList();
        }
    },
    data() {
        return {
            JobAssNo: this.JobNo,
            JobId: this.allModuleId,
            containerList: [],
            editIndex: null, // Tracks which row is being edited
            editableRow: {}, // Holds the row data being edited
            alert: {
                content: "Added Succesfully",
                ok: "ok",
            },
            validateContainer: true,
            errorContainerList: {
                gross_weight: "",
                measurement: "",
                net_weight: "",
                tare_weight: "",
            },
            containerErrorMessages: [
                "Please enter Gross Weight",
                "Please enter Measurement",
                "Please enter Net Weight",
                "Please enter Tare Weight",
            ],
            selectAllContainers: false,
        };
    },
    components: {
        ModelListSelect,
        MultiSelect,
        Multiselect,
    },
    computed: {
        isIndeterminate() {
            const selectable = this.containerList.filter(c => !c.containerWithSplit);
            const selected = selectable.filter(c => c.selected);
            return selected.length > 0 && selected.length < selectable.length;
        },
        selectedContainersCount() {
            return this.containerList.filter(c => c.selected && !c.containerWithSplit).length;
        },
        selectableContainersCount() {
            return this.containerList.filter(c => !c.containerWithSplit).length;
        },
        hasSelectedContainers() {
            return this.selectedContainersCount > 0;
        }
    },
    created() {

    },
    methods: {
        toggleSelectAll() {
            const shouldSelect = this.selectAllContainers;
            this.containerList.forEach(item => {
                if (!item.containerWithSplit) {
                    this.$set(item, 'selected', shouldSelect);
                }
            });
            this.$emit('selection-change', this.containerList.filter(i => i.selected));
        },
        updateSelectAll() {
            const selectable = this.containerList.filter(c => !c.containerWithSplit);
            const selected = selectable.filter(c => c.selected);
            if (selected.length === 0) {
                this.selectAllContainers = false;
            } else if (selected.length === selectable.length) {
                this.selectAllContainers = true;
            } else {
                this.selectAllContainers = false; // keep checkbox unchecked while indeterminate
            }
            this.$emit('selection-change', this.containerList.filter(i => i.selected));
        },
        editContainer(item, index) {
            // Set the editable row and index
            this.editIndex = index;
            this.editableRow = item; // Create a copy to avoid direct mutation
        },
        cancelEdit() {
            // Reset edit state without saving changes
            this.editIndex = null;
            this.editableRow = {};
        },
        validateContainerFunc() {
            let validate_new = true;
            Object.keys(this.errorContainerList).map((x, index) => {
                if (this.editableRow[x] == "") {
                    this.errorContainerList[x] = this.containerErrorMessages[index];
                    validate_new = false;
                }
            });
            if (validate_new != true) {
                this.validateContainer = false;
            } else {
                this.validateContainer = true;
            }
        },
        saveContainer(index) {
            this.validateContainerFunc();
            console.log("Updated Row errorContainerList:", this.errorContainerList);
            // Validate and save the updated data
            if (this.allModuleId && this.ClientId && this.MultiClientId && this.ffFclConsoExportId) {
                if (this.editableRow.containerNo && this.editableRow.containerType && this.validateContainer != false) {

                    console.log("Updated Row Data:", this.editableRow);

                    let payLoad = {
                        fk_conso_multiple_client_id:this.MultiClientId,
                        fk_client_id:this.ClientId,
                        fk_ff_conso_export_id:this.ffFclConsoExportId,
                        fk_all_module_id:this.allModuleId,
                        containerNo:this.editableRow.containerNo,
                        fk_container_id:this.editableRow.uniqueContainerId,
                        allModuleId:this.editableRow.allModuleId,
                        tare_weight:this.editableRow.tare_weight,
                        net_weight:this.editableRow.net_weight,
                        measurement:this.editableRow.measurement,
                        gross_weight:this.editableRow.gross_weight,
                        cccm_id:this.editableRow.cccm_id,

                    }
                    // Optional: Call an API to save the changes to the backend
                    NodeLockPannelService.updateConsolidationJobContainer(payLoad)
                        .then(response => {
                            const { data, status, statusText } = response;
                            this.editIndex = null; // Reset edit state
                            this.editableRow = {};
                            console.log("Update successful:", response.data);
                            this.alert.content = data.message;
                            this.$refs["addPop"].open();
                            this.getContainerList();
                            this.$emit('update', this.localData);
                        })
                        .catch(error => {
                            console.error("Update failed:", error);
                        });
                } else {
                    console.error("Please fill out all required fields.");
                }
            } else {
                console.error("Please fill out all required fields.");
            }
        },
        async getContainerList() {

            if (this.allModuleId) {// && this.ClientId && this.MultiClientId && this.ffFclConsoExportId
                let payLoad = {
                    allModuleId: this.allModuleId,
                    fk_conso_multiple_client_id: this.MultiClientId,
                    fk_client_id: this.ClientId,
                    fk_ff_conso_export_id: this.ffFclConsoExportId,
                    fk_container_id: "",
                    fk_all_module_id: this.allModuleId,
                };
                NodeLockPannelService.getJobConsolidationContainerList(payLoad)
                    .then((response) => {
                        const { data, status, statusText } = response;
                        if (status == 200 && data) {
                            this.containerList = data.data.map(function(row){
                                return Object.assign({}, row, { selected: false });
                            });
                            console.log("data PS=>", data);
                        }
                    })
                    .catch((error) => {
                        console.log("Catch on getContainerList Error: ", error);
                    });
            }
        },

    }
};
</script>


// WEBPACK FOOTER //
// UpdateContainerWithClient.vue?93e5abc4